import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function SacolaVaziaFallback() {
  return (
    <div
      style={{
        paddingTop: theme.spacing[5],
        paddingRight: theme.spacing[4],
        paddingLeft: theme.spacing[4],
        paddingBottom: theme.spacing[5],
        gap: theme.spacing[5],
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: theme.spacing[5],
        }}
      >
        <Skeleton style={{ width: '45vw', height: 25 }} />
        <Skeleton style={{ width: '65vw', height: 22 }} />
      </div>
    </div>
  );
}
